export const StarPin = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14.08 14.08"
    >
      <defs></defs>
      <polygon
        className="razz-fill"
        points="8.37 3.78 11.99 2.03 10.29 5.67 14.08 7 10.3 8.37 12.05 11.99 8.41 10.29 7.09 14.08 5.72 10.3 2.09 12.05 3.8 8.41 0 7.08 3.78 5.71 2.03 2.09 5.67 3.8 7 0 8.37 3.78"
      />
    </svg>
  );
};
